import React from "react";

import LinearProgress from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Grid } from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { joinByKeys } from "../../Js/Common";

const StudentProgress = (props) => {
  // Set class list
  const filterClass = (classId) => {
    let findObj = props.classes.find((obj) => {
      return obj.id == classId;
    });
    return findObj.value || "";
  };

  // Load Dynamic Image
  const loadImage = (rank) => {
    switch (rank) {
      case 1:
       // return require('../../assets/gold_cup.png');
      case 2:
        //return require('../../assets/silver_cup.png');
      case 3:
       // return require('../../assets/copper_cup.png');
      case "default":
       // return require('../../assets/copper_cup.png');
    }
  };

  return (
    <Box
      sx={{
        borderBottom: 1,
        borderBottomColor: "#A9A9A9",
        py: 1,
        cursor: "pointer",
      }}
      onClick={props.redirectTo}
    >
      <Grid
        container
        sx={{
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Grid>
          <Typography
            sx={{
              color: "#5f5600ff",
              fontWeight: "500",
              fontSize: "0.9rem",
              "@media (min-width: 1636px)": {
                fontSize: "1.4rem",
              },
            }}
          >
            {(props.isRank
              ? props.data.rank == 0
                ? ""
                : props.data.rank + `. `
              : props.index + 1 + `. `) +
              joinByKeys(props.data.name, ["firstname", "lastname"], " ")}
          </Typography>
        </Grid>
        {props.data.belongs_to && (
          <Grid sx={{ pr: 20 }}>
            <Typography
              sx={{
                color: "#A9A9A9",
                fontWeight: "500",
                fontSize: "0.9rem",
                "@media (min-width: 1636px)": {
                  fontSize: "1.4rem",
                },
              }}
            >
              {filterClass(props.data.belongs_to)}
            </Typography>
          </Grid>
        )}
      </Grid>
      <Grid
        container
        sx={{ flexDirection: "row", justifyContent: "flex-start" }}
      >
        <Grid item xs={10}>
          <Box sx={{ position: "relative" }}>
            <LinearProgress
              variant="determinate"
              value={props.data.percentage}
              sx={{
                height: "24px",
                borderRadius: 25,
                backgroundColor: "#a3d39aff",
                "@media (min-width: 1636px)": {
                  height: "34px",
                },
              }}
            />
            <Box sx={{ minWidth: 35, position: "absolute", top: 2, right: 20 }}>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                  fontSize: "1rem",
                  fontWeight: "bold",
                  color: "#FFFFFF",
                  "@media (min-width: 1636px)": {
                    fontSize: "1.4rem",
                  },
                }}
              >
                {`${Math.round(props.data.percentage)}%`}
              </Typography>
            </Box>
          </Box>
          {props.data.totalAssets && (
            <Box>
              <Grid
                container
                sx={{
                  flexDirection: "row",
                  justifyContent: "space-around",
                  alignItems: "center",
                }}
              >
                <Grid item xs={8}>
                  <Typography
                    sx={{
                      color: "#A9A9A9",
                      fontSize: "0.8rem",
                      "@media (min-width: 1636px)": {
                        fontSize: "1.2rem",
                      },
                    }}
                  >
                    Total Assets: {props.data.totalAssets} | Attempted Assets:{" "}
                    {props.data.attemptedassets}
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography
                    sx={{
                      color: "#A9A9A9",
                      fontSize: "0.8rem",
                      "@media (min-width: 1636px)": {
                        fontSize: "1.2rem",
                      },
                    }}
                  >
                    View all Tasks
                  </Typography>
                </Grid>
                <Grid item sx={{ color: "#A9A9A9", paddingTop: "0.1rem" }}>
                  <KeyboardArrowRightIcon
                    sx={{
                      fontSize: "1rem",
                      "@media (min-width: 1636px)": {
                        fontSize: "1.2rem",
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </Box>
          )}
        </Grid>
        {props.isScoreDisplay && (
          <Grid xs={2} sx={{ textAlign: "center" }}>
            <Box
              sx={{
                border: 1,
                borderRadius: 15,
                color: "primary.subhead",
                mx: 2,
              }}
            >
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                  fontSize: "0.9rem",
                  fontWeight: "bold",
                  color: "#A9A9A9",
                  textAlign: "center",
                  paddingTop: "0.05rem",
                  "@media (min-width: 1636px)": {
                    fontSize: "1.4rem",
                  },
                }}
              >
                {`${Math.round(props.data.percentage)}%`}
              </Typography>
            </Box>
            <Box sx={{ marginTop: "0.1rem" }}>
              <Typography
                sx={{
                  color: "#A9A9A9",
                  fontSize: "0.8rem",
                  "@media (min-width: 1636px)": {
                    fontSize: "1.2rem",
                  },
                }}
              >
                Score
              </Typography>
            </Box>
          </Grid>
        )}
        {props.isCupDisplay && (
          <Box sx={{ ml: 1, mt: -1.5 }}>
            <img
              src={
                props.isRank
                  ? loadImage(+props.data.rank)
                  : loadImage(props.index + 1)
              }
              width="50rem"
            ></img>
          </Box>
        )}
      </Grid>
    </Box>
  );
};

export default StudentProgress;
